module.exports = __webpack_public_path__ + "static/media/v37.5a9cd1d9.mp4";